<template>
    <div class="apprentice-simple-card images-list">
        <b-button
            class="btn-add btn-add-category"
            variant="primary"
            @click="showCreateModal()">
            {{ $t('templates.new_category') }}
        </b-button>

        <v-server-table
            ref="table"
            :columns="categoryTableColumns"
            :options="categoryTableOptions"
            :url="getTemplatesUrl"
            name="template-table">
            <div
                class="type_id"
                slot="type_id"
                slot-scope="{ row }">
                <span v-if="row.type_id === 1">{{ $t('templates.magazine') }}</span
                ><span v-if="row.type_id === 2">{{ $t('templates.year_book') }}</span>
            </div>

            <div
                class="page_size"
                slot="page_size"
                slot-scope="{ row }">
                {{ row.size.title }}
            </div>

            <div
                class="actions"
                slot="actions"
                slot-scope="{ row }">
                <b-button
                    class="btn-open"
                    v-b-tooltip.hover
                    :href="goToTemplatesUrl(row.id)"
                    :title="$t('templates.templates')"
                    variant="primary-icon-only"></b-button>
                <b-button
                    class="btn-remove btn-remove-category"
                    v-b-tooltip.hover
                    :title="$t('common.delete')"
                    variant="danger-icon-only"
                    @click="onRemove(row.id)"></b-button>
            </div>
        </v-server-table>

        <b-modal
            v-model="category_modal"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            modal-class="apprentice-default-modal"
            :ok-title="$t('common.cancel')"
            ok-variant="primary"
            size="md"
            :title="$t('templates.new_category')"
            @ok="submitCategory">
            <div class="create-category">
                <div
                    class="errors"
                    v-if="hasFoundError">
                    <b-alert
                        v-for="(error, index) in errors"
                        v-if="error.error"
                        :key="index"
                        show
                        variant="danger">
                        {{ error.message }}
                    </b-alert>
                </div>

                <b-form-group
                    :label="$t('common.title')"
                    label-for="template-title-input">
                    <b-form-input
                        id="template-title-input"
                        v-model="form.title"
                        :placeholder="$t('common.title')"
                        required>
                    </b-form-input>
                </b-form-group>

                <div class="format-and-type">
                    <b-form-group
                        :label="$t('templates.size')"
                        label-for="template-page-size-input">
                        <b-form-select
                            class="apprentice-primary-select"
                            id="template-page-size-input"
                            v-model="form.page_size"
                            :options="pagesizes"
                            required>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group
                        label="Type:"
                        label-for="template-type-input">
                        <b-form-select
                            class="apprentice-primary-select"
                            id="template-type-input"
                            v-model="form.type_id"
                            :options="types"
                            required>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'design-2021-template-category-component',
    props: ['pagesizesIn', 'typesIn'],
    data() {
        return {
            getTemplatesUrl: baseUrl + '/template/category/get',
            pagesizes: this.getPageSize(),
            types: this.getTypes(),
            categoryTableColumns: ['title', 'page_size', 'type_id', 'actions'],
            categoryTableOptions: {
                headings: {
                    title: 'Titel',
                    page_size: this.$t('templates.size'),
                    type_id: 'Type',
                    actions: this.$t('common.actions'),
                },
                saveState: true,
                sortIcon: {
                    base: 'fad',
                    is: 'fa-sort',
                    up: 'fa-sort-up',
                    down: 'fa-sort-down',
                },
                sortable: ['title'],
            },
            category_modal: false,
            form_new: true,
            form: {
                id: '',
                title: '',
                page_size: 0,
                type_id: 0,
            },
            hasFoundError: false,
            errors: {
                title: {
                    error: true,
                    message: this.$t('templates.title_cannot_be_empty'),
                },
                page_size: {
                    error: true,
                    message: this.$t('templates.you_have_not_selected_a_size_yet'),
                },
                type: {
                    error: true,
                    message: this.$t('templates.you_have_not_selected_a_type_yet'),
                },
            },
        };
    },
    methods: {
        getPageSize() {
            let pageSizes = [];
            if (this.pagesizesIn.length >= 1) {
                pageSizes = this.pagesizesIn.map((pageSize) => {
                    return {
                        text: pageSize.title,
                        value: pageSize.id,
                    };
                });

                pageSizes.unshift({
                    text: this.$t('templates.choose_a_size'),
                    value: 0,
                });
            }

            return pageSizes;
        },

        getTypes() {
            let types = [];
            if (this.typesIn.length >= 1) {
                types = this.typesIn.map((pageSize) => {
                    return {
                        text: pageSize.title,
                        value: pageSize.id,
                    };
                });

                types.unshift({
                    text: this.$t('templates.choose_a_type'),
                    value: 0,
                });
            }

            return types;
        },

        goToTemplatesUrl(id) {
            return baseUrl + '/template/templates/' + id;
        },
        onRemove(id) {
            this.alert
                .confirm(
                    this.$t('templates.delete_category'),
                    this.$t('templates.are_you_sure_you_want_to_delete_this_category'),
                    this.$t('common.delete'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();
                        this.axios.delete('/template/category/delete/' + id).then(
                            (response) => {
                                this.$refs.table.refresh();
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        showCreateModal() {
            this.resetForm();
            this.category_modal = true;
        },
        resetForm() {
            this.form.id = '';
            this.form.title = '';
            this.form.page_size = 0;
            this.form.type_id = 0;
        },
        submitCategory(bvModalEvent) {
            if (this.hasError()) {
                bvModalEvent.preventDefault();
                return;
            }

            this.alert.saving();

            if (this.form.id == '') {
                this.axios.post('/template/category/add', this.form).then((response) => {
                    this.category_modal = false;
                    this.resetForm();
                    this.$refs.table.refresh();
                    this.alert.success();
                });
            } else {
                this.axios.post('/template/category/edit', this.form).then((response) => {
                    this.category_modal = false;
                    this.resetForm();
                    this.$refs.table.refresh();
                    this.alert.success();
                });
            }
        },

        hasError() {
            this.clearErrors();

            if (this.form.title === '') {
                this.hasFoundError = true;
                this.errors.title.error = true;
            }

            if (this.form.page_size === 0) {
                this.hasFoundError = true;
                this.errors.page_size.error = true;
            }

            if (this.form.type_id === 0) {
                this.hasFoundError = true;
                this.errors.type.error = true;
            }

            return this.hasFoundError;
        },

        clearErrors() {
            this.hasFoundError = false;
            this.errors.title.error = false;
            this.errors.page_size.error = false;
            this.errors.type.error = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.format-and-type {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .form-group,
    select {
        width: 100%;
    }

    .form-group {
        margin-bottom: 0;
    }
}

.actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .btn-remove-category {
        &:not(:first-child) {
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.btn-add-category {
    margin-left: auto;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.errors {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .btn-add-category {
        float: right;
        margin-bottom: 0;
        margin-top: map-get($grid-gutter-spacing, 'eight');
    }

    .format-and-type {
        flex-direction: row;

        .form-group {
            width: calc(50% - 15px);
        }
    }
}
</style>
